'use es6'; // This context is provided by ui-library. This pattern will need to be
// revisited when UIComponents migrated from ui-library to the wpxds sandbox editor.

import { createContext } from 'react';
export const SandboxContext = /*#__PURE__*/createContext({
  sandboxed: false
});
SandboxContext.displayName = 'SandboxContext';
const {
  Consumer,
  Provider
} = SandboxContext;
export { Provider as SandboxContextProvider };
export { Consumer as SandboxContextConsumer };